import React, { useState, useEffect } from 'react';
import { Play, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getReleases, getImageUrl } from '../../utils/api';
import { releases as mockReleases } from '../../data/mockData';
import './LatestReleases.css';

const LatestReleases = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredRelease, setHoveredRelease] = useState(null);

  useEffect(() => {
    fetchReleases();
  }, []);

  const fetchReleases = async () => {
    try {
      const data = await getReleases();
      if (data && data.length > 0) {
        // Format releases from API to match expected structure
        const formattedReleases = data.map(release => ({
          ...release,
          artist: release.artist_name || release.artist,
          streamLink: release.stream_link || release.streamLink
        }));
        setReleases(formattedReleases);
      } else {
        setReleases(mockReleases);
      }
    } catch (error) {
      console.log('Using mock data for releases');
      setReleases(mockReleases);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="releases" className="latest-releases">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Latest Releases</span>
            <h2>New music, released with purpose</h2>
            <p>A growing catalog of records built for late nights, long drives, club rooms, headphones, and everything after.</p>
          </div>
          <div className="loading-spinner">Loading releases...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="releases" className="latest-releases">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Latest Releases</span>
          <h2>New music, released with purpose</h2>
          <p>A growing catalog of records built for late nights, long drives, club rooms, headphones, and everything after.</p>
        </div>

        <div className="releases-grid">
          {releases.map((release) => (
            <Link
              to={`/releases/${release.slug || release.id}`}
              key={release.id}
              className="release-card fade-in"
              data-testid={`release-card-${release.id}`}
              onMouseEnter={() => setHoveredRelease(release.id)}
              onMouseLeave={() => setHoveredRelease(null)}
            >
              <div className="release-artwork-wrapper">
                <img 
                  src={getImageUrl(release.artwork)} 
                  alt={`${release.title} by ${release.artist}`}
                  className="release-artwork"
                  loading="lazy"
                />
                
                {/* Mosaic Overlay */}
                <div className="mosaic-overlay">
                  <div className="mosaic-piece piece-1"></div>
                  <div className="mosaic-piece piece-2"></div>
                  <div className="mosaic-piece piece-3"></div>
                  <div className="mosaic-piece piece-4"></div>
                </div>

                <div className={`release-overlay ${hoveredRelease === release.id ? 'visible' : ''}`}>
                  <div className="play-button" aria-label={`View ${release.title}`}>
                    <Play size={32} fill="currentColor" />
                  </div>
                </div>
              </div>

              <div className="release-info">
                <h3>{release.title}</h3>
                <p className="release-artist">{release.artist || release.artist_name}</p>
                <div className="release-meta">
                  <span className="release-genre">{release.genre}</span>
                  <span className="stream-link">
                    <span>View</span>
                    <ExternalLink size={14} />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="all-releases-cta fade-in">
          <Link to="/releases" className="btn btn-primary">
            View All Music
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestReleases;
